var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h5", { staticClass: "message my-5" }, [
      _vm._v(
        " No cierre sesión o cambie de empresa mientras está en el proceso de enrolamiento "
      )
    ]),
    _c(
      "form",
      {
        attrs: { "data-vv-scope": "data-form" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.solicitarVerificacionIdentidad($event)
          }
        }
      },
      [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c("label", [_vm._v("Número de serie")]),
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  id: "serialNumber",
                  name: "serialNumber",
                  "data-vv-as": "serialNumber",
                  state: !this.errors.has("data-form.serialNumber"),
                  placeholder: "Ingrese su número de carnet"
                },
                model: {
                  value: _vm.serialNumber,
                  callback: function($$v) {
                    _vm.serialNumber = $$v
                  },
                  expression: "serialNumber"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c("label", [_vm._v("Comuna")]),
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  type: "commune",
                  id: "commune",
                  name: "commune",
                  "data-vv-as": "commune",
                  state: !this.errors.has("data-form.commune"),
                  placeholder: "Ingrese Comuna"
                },
                model: {
                  value: _vm.commune,
                  callback: function($$v) {
                    _vm.commune = $$v
                  },
                  expression: "commune"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c("label", [_vm._v("Correo")]),
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  type: "email",
                  id: "email",
                  name: "email",
                  "data-vv-as": "email",
                  state: !this.errors.has("data-form.email"),
                  placeholder: "Ingrese Correo"
                },
                model: {
                  value: _vm.email,
                  callback: function($$v) {
                    _vm.email = $$v
                  },
                  expression: "email"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mt-2" }, [
          _c(
            "div",
            { staticClass: "col-6" },
            [
              !_vm.loading
                ? _c(
                    "b-button",
                    {
                      attrs: {
                        title: "Solicitar código de verificación",
                        disabled: _vm.isDisabled,
                        variant: "primary"
                      },
                      on: { click: _vm.solicitarVerificacionIdentidad }
                    },
                    [_vm._v(" Solicitando Verificación de identidad ")]
                  )
                : _vm._e(),
              _vm.loading
                ? _c(
                    "b-button",
                    {
                      attrs: {
                        title: "Solicitando código de verificación",
                        variant: "primary"
                      }
                    },
                    [
                      _vm._v(" Solicitando Verificación de identidad "),
                      _vm.loading
                        ? _c("b-spinner", {
                            attrs: { small: "", variant: "info" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }